import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {PaymentMethodTable} from './table/PaymentMethodTable'
import {PaymentMethodEditModal} from './payment-methods-edit-modal/PaymentMethodEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {PaymentMethodListHeader} from './header/PaymentMethodListHeader'
import { ToastContainer } from 'react-toastify'

const PaymentMethodList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ToastContainer/>
        <PaymentMethodListHeader />
        <PaymentMethodTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <PaymentMethodEditModal />}
    </>
  )
}

const PaymentMethodListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PaymentMethodList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PaymentMethodListWrapper}
